import { render, staticRenderFns } from "./PickupForm.vue?vue&type=template&id=19f7c1ea&"
import script from "./PickupForm.vue?vue&type=script&lang=js&"
export * from "./PickupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports